import { createContext } from 'react';
import { MemoriesContextProps } from './interfaces/memories-context-props-interface';

const MemoriesContext = createContext<MemoriesContextProps>({} as MemoriesContextProps);

export default MemoriesContext;
